export interface RecurringSeries {
  id: string;
  title: string;
  status: 'PENDING_QUOTE' | 'QUOTED' | 'ACTIVE' | 'PAUSED' | 'CANCELLED' | 'ENDED';
  requestId: string;
  requestStatus: string;
  origin: { address: string; lat: number; lng: number };
  destination: { address: string; lat: number; lng: number };
  passengers: number;
  roundTrip: boolean;
  startDate: string;
  endDate: string | null;
  pattern: { type: string; days?: number[]; dates?: string[] };
  patternLabel: string;
  outboundTime: string;
  returnTime: string | null;
  customer: { name: string };
  driver: { name: string } | null;
  pricing: { billingMode: string; amount: string; currency: string } | null;
  generatedUntil: string | null;
  exceptions?: Array<{ id: string; date: string; leg: string | null; type: string; newTime: string | null; note: string | null }>;
  occurrences?: Array<{ id: string; date: string; leg: 'OUTBOUND' | 'RETURN'; scheduledAt: string; status: string; ride: { id: string; code: string; status: string; payment: { status: string; balance: string } | null } | null }>;
  packages?: Array<{ id: string; billingMode: string; status: string; periodStart: string; periodEnd: string; ridesIncluded: number | null; ridesScheduled: number; ridesCompleted: number; amount: string; payment: { id: string; status: string; farePaid: string; balance: string } | null }>;
  perRideTotals?: { farePaid: string; balance: string } | null;
  canManage?: boolean;
}

export const SERIES_STATUS: Record<RecurringSeries['status'], [string, 'info' | 'warning' | 'success' | 'neutral' | 'danger']> = {
  PENDING_QUOTE: ['Esperando cotización', 'info'],
  QUOTED: ['Cotizada', 'warning'],
  ACTIVE: ['Activa', 'success'],
  PAUSED: ['Pausada', 'warning'],
  CANCELLED: ['Cancelada', 'danger'],
  ENDED: ['Finalizada', 'neutral'],
};

export const BILLING_LABEL: Record<string, string> = { PER_RIDE: 'Por viaje', WEEKLY: 'Semanal', MONTHLY: 'Mensual', PACKAGE: 'Paquete' };
export const DAY_SHORT = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
